import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('cq_admin_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export async function track(event, properties = {}, lead_id = null) {
  try {
    await api.post('/analytics/event', { event, properties, lead_id });
  } catch (e) {
    // analytics is best-effort — log without breaking UX
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[analytics] event "${event}" failed to send:`, e?.message || e);
    }
  }
}
